import React, { useEffect, useRef } from 'react';
import * as DarkReader from 'darkreader';
import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
import { useDispatch } from 'react-redux';
import { slideAction } from '../../store/slideSlice';
import DarkModeToggle, { useDarkMode } from '../DarkModeToggle';

const DARK_MODE_THEME = { brightness: 100, contrast: 90, sepia: 10 };

const DARK_MODE_FIXES = { disableStyleSheetsProxy: true };

function Modes({ scale }) {
    const { dark } = useDarkMode();
    const dispatch = useDispatch();
    const applied = useRef(null);

    useEffect(() => {
        if (applied.current === dark) return;
        applied.current = dark;

        if (dark) {
            DarkReader.setFetchMethod(window.fetch);
            enableDarkMode(DARK_MODE_THEME, DARK_MODE_FIXES);
        } else {
            disableDarkMode();
        }
        dispatch(slideAction.setDarkMode(!dark));
    }, [dark, dispatch]);

    return <DarkModeToggle scale={scale} />;
}

export default Modes;
